// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { TaskTypeEnum } from './taskTypeEnum';
import type { ExportedTaskDescription } from './exportedTaskDescription';
import type { ExportedTaskObjectives } from './exportedTaskObjectives';
import type { ExportedTaskLevel } from './exportedTaskLevel';
import type { ExportedResource } from './exportedResource';

/**
 * Task export format
 */
export interface ExportedTask {
  type: TaskTypeEnum;
  title: string;
  description?: ExportedTaskDescription;
  objectives?: ExportedTaskObjectives;
  level?: ExportedTaskLevel;
  sort_index?: number;
  resources?: ExportedResource[];
}
